import React from 'react';
import SchedulerCalendar from '../../../components/calendar/SchedulerCalendar';
const GRAN_TIERRA_ID = '5605e27b-5129-4e07-b57d-4d98294e6df5';

export default function ViewGranTierra() {
  return (
    <div className="operation-view grantierra-view">
      <SchedulerCalendar operationId={GRAN_TIERRA_ID} />
    </div>
  );
}